/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AuthCallBackLineRequest } from "../models/AuthCallBackLineRequest";
import type { AuthCallBackLineResponseApiRespoonse } from "../models/AuthCallBackLineResponseApiRespoonse";
import type { AuthCallbackUpdateLineRequest } from "../models/AuthCallbackUpdateLineRequest";
import type { AuthCallbackUpdateLineResponseApiRespoonse } from "../models/AuthCallbackUpdateLineResponseApiRespoonse";
import type { AuthGetUrlLineRequest } from "../models/AuthGetUrlLineRequest";
import type { AuthGetUrlLineResponseApiRespoonse } from "../models/AuthGetUrlLineResponseApiRespoonse";
import type { AuthGetUrlUpdateLineRequest } from "../models/AuthGetUrlUpdateLineRequest";
import type { AuthGetUrlUpdateLineResponseApiRespoonse } from "../models/AuthGetUrlUpdateLineResponseApiRespoonse";
import type { AuthLoginRequest } from "../models/AuthLoginRequest";
import type { AuthLoginResponseApiRespoonse } from "../models/AuthLoginResponseApiRespoonse";
import type { AuthLogoutRequest } from "../models/AuthLogoutRequest";
import type { AuthLogoutResponseApiRespoonse } from "../models/AuthLogoutResponseApiRespoonse";
import type { AuthMemberLoginRequest } from "../models/AuthMemberLoginRequest";
import type { AuthMemberLoginResponseApiRespoonse } from "../models/AuthMemberLoginResponseApiRespoonse";
import type { AuthMemberLogoutRequest } from "../models/AuthMemberLogoutRequest";
import type { AuthMemberLogoutResponseApiRespoonse } from "../models/AuthMemberLogoutResponseApiRespoonse";
import type { AuthMeRequest } from "../models/AuthMeRequest";
import type { AuthMeResponseApiRespoonse } from "../models/AuthMeResponseApiRespoonse";
import type { AuthRefreshTokenRequest } from "../models/AuthRefreshTokenRequest";
import type { AuthRefreshTokenResponseApiRespoonse } from "../models/AuthRefreshTokenResponseApiRespoonse";
import type { AuthUpdatePasswordRequest } from "../models/AuthUpdatePasswordRequest";
import type { AuthUpdatePasswordResponseApiRespoonse } from "../models/AuthUpdatePasswordResponseApiRespoonse";
import type { AuthUpdateProfileRequest } from "../models/AuthUpdateProfileRequest";
import type { AuthUpdateProfileResponseApiRespoonse } from "../models/AuthUpdateProfileResponseApiRespoonse";

import type { CancelablePromise } from "../core/CancelablePromise";
import { OpenAPI } from "../core/OpenAPI";
import { request as __request } from "../core/request";

export class AuthService {
  /**
   * ログイン
   * @param requestBody
   * @returns AuthMemberLoginResponseApiRespoonse 正常レスポンス
   * @throws ApiError
   */
  public static authMemberLogin(
    requestBody: AuthMemberLoginRequest
  ): CancelablePromise<AuthMemberLoginResponseApiRespoonse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/auth/member-login",
      body: requestBody,
      mediaType: "applicatin/json",
      errors: {
        400: `Fail to process.`,
        401: `fail to authentication`,
        419: `token mismatch`,
      },
    });
  }

  /**
   * ログイン
   * @param requestBody
   * @returns AuthLoginResponseApiRespoonse 正常レスポンス
   * @throws ApiError
   */
  public static authLogin(
    requestBody: AuthLoginRequest
  ): CancelablePromise<AuthLoginResponseApiRespoonse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/auth/login",
      body: requestBody,
      mediaType: "applicatin/json",
      errors: {
        400: `Fail to process.`,
        401: `fail to authentication`,
        419: `token mismatch`,
      },
    });
  }

  /**
   * Refresh token
   * @param requestBody
   * @returns AuthRefreshTokenResponseApiRespoonse 正常レスポンス
   * @throws ApiError
   */
  public static authRefreshToken(
    requestBody: AuthRefreshTokenRequest
  ): CancelablePromise<AuthRefreshTokenResponseApiRespoonse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/auth/refresh-token",
      body: requestBody,
      mediaType: "applicatin/json",
      errors: {
        400: `Fail to process.`,
        401: `fail to authentication`,
        419: `token mismatch`,
      },
    });
  }

  /**
   * Refresh token
   * @param requestBody
   * @returns AuthRefreshTokenResponseApiRespoonse 正常レスポンス
   * @throws ApiError
   */
  public static memberRefreshToken(
    requestBody: AuthRefreshTokenRequest
  ): CancelablePromise<AuthRefreshTokenResponseApiRespoonse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/member/refresh-token",
      body: requestBody,
      mediaType: "applicatin/json",
      errors: {
        400: `Fail to process.`,
        401: `fail to authentication`,
        419: `token mismatch`,
      },
    });
  }

  /**
   * ログアウト
   * @param requestBody
   * @returns AuthLogoutResponseApiRespoonse 正常レスポンス
   * @throws ApiError
   */
  public static authLogout(
    requestBody: AuthLogoutRequest
  ): CancelablePromise<AuthLogoutResponseApiRespoonse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/auth/logout",
      body: requestBody,
      mediaType: "applicatin/json",
      errors: {
        400: `Fail to process.`,
        401: `fail to authentication`,
        419: `token mismatch`,
      },
    });
  }

  /**
   * ログアウト
   * @param requestBody
   * @returns AuthMemberLogoutResponseApiRespoonse 正常レスポンス
   * @throws ApiError
   */
  public static authMemberLogout(
    requestBody: AuthMemberLogoutRequest
  ): CancelablePromise<AuthMemberLogoutResponseApiRespoonse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/auth/member-logout",
      body: requestBody,
      mediaType: "applicatin/json",
      errors: {
        400: `Fail to process.`,
        401: `fail to authentication`,
        419: `token mismatch`,
      },
    });
  }

  /**
   * ログイン情報取得
   * この API を利用するには、ログイン済みである必要があります。
   * @param requestBody
   * @returns AuthMeResponseApiRespoonse 正常レスポンス
   * @throws ApiError
   */
  public static authMe(
    requestBody: AuthMeRequest
  ): CancelablePromise<AuthMeResponseApiRespoonse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/auth/me",
      body: requestBody,
      mediaType: "applicatin/json",
      errors: {
        400: `Fail to process.`,
        401: `fail to authentication`,
        419: `token mismatch`,
      },
    });
  }

  /**
   * ユーザ情報更新
   * @param requestBody
   * @returns AuthUpdateProfileResponseApiRespoonse 正常レスポンス
   * @throws ApiError
   */
  public static authUpdate(
    requestBody: AuthUpdateProfileRequest
  ): CancelablePromise<AuthUpdateProfileResponseApiRespoonse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/auth/update",
      body: requestBody,
      mediaType: "applicatin/json",
      errors: {
        400: `Fail to process.`,
        401: `fail to authentication`,
        419: `token mismatch`,
      },
    });
  }

  /**
   * パスワード更新
   * @param requestBody
   * @returns AuthUpdatePasswordResponseApiRespoonse 正常レスポンス
   * @throws ApiError
   */
  public static authUpdatePassword(
    requestBody: AuthUpdatePasswordRequest
  ): CancelablePromise<AuthUpdatePasswordResponseApiRespoonse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/auth/update-password",
      body: requestBody,
      mediaType: "applicatin/json",
      errors: {
        400: `Fail to process.`,
        401: `fail to authentication`,
        419: `token mismatch`,
      },
    });
  }

  /**
   * Get url line
   * @param requestBody
   * @returns AuthGetUrlLineResponseApiRespoonse 正常レスポンス
   * @throws ApiError
   */
  public static lineGetUrl(
    requestBody: AuthGetUrlLineRequest
  ): CancelablePromise<AuthGetUrlLineResponseApiRespoonse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/line/get-url",
      body: requestBody,
      mediaType: "applicatin/json",
      errors: {
        400: `Fail to process.`,
        401: `fail to authentication`,
        419: `token mismatch`,
      },
    });
  }

  /**
   * Callback line
   * @param requestBody
   * @returns AuthCallBackLineResponseApiRespoonse 正常レスポンス
   * @throws ApiError
   */
  public static lineLoginCallback(
    requestBody: AuthCallBackLineRequest
  ): CancelablePromise<AuthCallBackLineResponseApiRespoonse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/line/login/callback",
      body: requestBody,
      mediaType: "applicatin/json",
      errors: {
        400: `Fail to process.`,
        401: `fail to authentication`,
        419: `token mismatch`,
      },
    });
  }

  /**
   * Get url update line account id
   * @param requestBody
   * @returns AuthGetUrlUpdateLineResponseApiRespoonse 正常レスポンス
   * @throws ApiError
   */
  public static lineGetUrlUpdate(
    requestBody: AuthGetUrlUpdateLineRequest
  ): CancelablePromise<AuthGetUrlUpdateLineResponseApiRespoonse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/line/get-url-update",
      body: requestBody,
      mediaType: "applicatin/json",
      errors: {
        400: `Fail to process.`,
        401: `fail to authentication`,
        419: `token mismatch`,
      },
    });
  }

  /**
   * Callback update line
   * @param requestBody
   * @returns AuthCallbackUpdateLineResponseApiRespoonse 正常レスポンス
   * @throws ApiError
   */
  public static lineUpdateCallback(
    requestBody: AuthCallbackUpdateLineRequest
  ): CancelablePromise<AuthCallbackUpdateLineResponseApiRespoonse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/line/update/callback",
      body: requestBody,
      mediaType: "applicatin/json",
      errors: {
        400: `Fail to process.`,
        401: `fail to authentication`,
        419: `token mismatch`,
      },
    });
  }
}
